export default function isExternalLink(url) {
    const tmp = document.createElement('a');
    tmp.href = url;
    return !tmp.host.includes(window.location.host);
}